<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cell-click="chooseRow"
            :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>

      </template>
    </x-grid>


    <!-- 详情页 -->
    <a-modal
        title="工作流配置"
        centered
        :footer="null"
        :maskClosable="false"
        :closable="true"
        @cancel="closeEdit"
        :visible="editModalVisible"
        :width="1000"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <formDetail :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </formDetail>
    </a-modal>


  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'
import {loadBaseCodeData} from "@/services/baseCodeSource";
import {dataApi} from "@/services/workflow/workflow";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

const fac = XGrid.factory;


// 详情
import formDetail from '@/pages/web/workflow/workflow/workflowDetail';

//列表接口
const url = api.workflow.WORK_FLOW;

//主键
const rowId = 'bussinessWorkflowId';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("bussinessWorkflowId", "业务ID", 100),
  fac.makeColumn("bussinessName", "业务名称", 160),
  fac.makeColumn("processKey", "流程标识", 160),
  fac.makeColumn("remark", "备注", 130),
]

let formConfig = fac.makeFormConfig(columns, [
  {field: 'bussinessName'},
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  components: {
    formDetail
  },
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   delRow: 'DELETE',
  // },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,

    }
  },
  methods: {
    async delRow() {
      this.loading = true;
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }
      await dataApi.deleteRow(rows[0][this.rowId]).then(() => {
        this.$refs['grid'].$refs['xGrid'].removeCheckboxRow();
      }).catch(e => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false;
      })
    },
  }
}
</script>

<style scoped>
</style>